import { createContext, forwardRef } from "react";

export const TenantContext = createContext({});

export const withTenantContext = Component =>
  forwardRef((props, ref) => (
    <TenantContext.Consumer>
      {tenant => <Component {...props} tenant={tenant} ref={ref} />}
    </TenantContext.Consumer>
  ));
